import { EncodedStream } from '@fullstory/recording-api';
import { ArraySlice } from '@fullstory/shared/arrayslice';

export class LZJGWDecoder {
  private _seq: string[] = [];

  /** @returns the current fully-decoded sequence. */
  sequence(): string[] {
    return this._seq;
  }

  /**
   * Decodes the given compressed stream.
   * @returns an {@link ArraySlice} representing the newly-decoded part of the
   * stream.
   */
  decode(stream: EncodedStream): ArraySlice<string> {
    const start = this._seq.length;
    for (let idx = 0; idx < stream.length; ++idx) {
      const item = stream[idx];
      switch (typeof item) {
        case 'string':
          this._seq.push(item);
          break;
        case 'number':
          this._seq.push(this._seq[item] as string);
          break;
        case 'object':
          if (item == null) {
            this._seq.push('');
            break;
          }

          for (let j = 0; j < item[1]; j++) {
            this._seq.push(this._seq[item[0] + j] as string);
          }
          break;
      }
    }
    return new ArraySlice(this._seq, start);
  }
}
